/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Text } from '@chakra-ui/react';
import { IngestionDocumentReviewStatus } from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { Select, SelectProps } from '~/services/document/common/Select';
import { enumToLabel } from '~/services/document/utils/enums';
import { getDocumentReviewStatusColorFromStatus } from '../utils/documentReviewStatus.utils';

export interface IngestionDocumentReviewStatusOptions {
  label?: string;
  value: IngestionDocumentReviewStatus;
}

export const IngestionDocumentReviewStatusSelect: FC<
  SelectProps<IngestionDocumentReviewStatusOptions, false>
> = (props) => {
  const statusOptions = [
    {
      value: IngestionDocumentReviewStatus.APPROVED,
    },
    {
      value: IngestionDocumentReviewStatus.RETURNED,
    },
  ];

  return (
    <Select
      chakraStyles={{
        option: (
          provided: any,
          state: { isSelected: any; isFocused: any }
        ) => ({
          ...provided,
          bg: () => {
            if (!state.isSelected && state.isFocused) {
              return 'gray.200';
            }

            return state.isSelected ? 'primary.900' : 'transparent';
          },
          _dark: {
            color: () => {
              if (state.isSelected) {
                return 'black';
              }

              return 'whiteAlpha.700';
            },
            bg: () => {
              if (!state.isSelected && state.isFocused) {
                return 'whiteAlpha.100';
              }

              return state.isSelected ? 'primary.900' : 'transparent';
            },
          },
        }),
      }}
      formatOptionLabel={(option) => {
        return (
          <Text color={getDocumentReviewStatusColorFromStatus(option.value)}>
            {enumToLabel(option.value)}
          </Text>
        );
      }}
      getOptionLabel={(option) => {
        return enumToLabel(option.value);
      }}
      menuPortalTarget={window.document.body}
      options={statusOptions}
      placeholder="Select Status"
      size="sm"
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      {...props}
    />
  );
};
